import { requiredText } from 'shared/libs/text/requered-text'

import { RenderFormItem } from 'shared/ui/Form/FormItems'

export const resetPasswordFormFields: RenderFormItem[] = [
  {
    type: 'customPasswordField',
    itemProps: {
      placeholder: 'Новый пароль',
      className: 'text-dark leading-[20px] text-[14px]',
    },
    formItemProps: {
      name: 'new_password',
      rules: [{ required: true, message: requiredText }],
    },
  },
  {
    type: 'customPasswordField',
    itemProps: {
      placeholder: 'Повторный ввод нового пароля',
      className: 'text-dark leading-[20px] text-[14px]',
    },
    formItemProps: {
      name: 'new_password_verify',
      rules: [{ required: true, message: requiredText }],
    },
  },
]
